import { render } from "./OapTechDetails.vue?vue&type=template&id=c268eaec"
import script from "./OapTechDetails.vue?vue&type=script&lang=js"
export * from "./OapTechDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__